export const appName = 'BG Immigration';
export const phone = '+918405885058';
export const phoneDisplay = '+91-84058-85058';
export const altPhone = '';
export const altPhoneDisplay = '';
export const email = 'info@bgimmigration.net';
export const location = 'SCO: 84-85 Sector 13 Main Market Karnal, Haryana, India-132001';
export const pageTitle = {
    "/contact": "Contact Us",
    "/about": "About Us",
    "/immigration/family": "Family Sponsorship",
    "/immigration/spouse" : "Spouse Sponsorship",
    "/immigration/expressentry": "Express Entry",
    "/immigration/pnp": "Provincial Nomination",
    "/immigration/hnc": "Humanitarian And Compassionate Ground",
    "/visa/business": "Business Visa",
    "/visa/caregiver": "Care Giver Work Permit",
    "/visa/student": "Student Visa",
    "/visa/super": "Super Visa",
    "/visa/visitor": "Visitor Visa",
    "/visa/work": "Work Permit",
    "/news": "News",
    "/faqs": "Frequently Asked Questions",
    "/login": "Login",
    "/services": "Our Services",
    "/testimonial": "Testimonial",
    "/feedback": "Feedback",
    "/calculators/bc-pnp": "BC PNP Point Calculator",
    "/calculators/bc-pnp-business": "BC PNP Entrepreneur Immigration Point Calculators",
    "/calculators/skilled-worker": "Canada 67 Point Calculator / Skilled Worker Calculator",
    "/calculators/sinp": "Saskatchewan PNP (SINP) Point Calculator",
    "/calculators/nova-scotia": "Nova Scotia Immigration Points Calculator",
    "/calculators/crs":"Canada CRS Score Calculator"
}

export const headerBg = {
    "/immigration/family" : "family-sponsorship",
    "/immigration/spouse" : "spouse-sponsorship",
    "/immigration/expressentry": "express-entry",
    "/immigration/pnp": "pnp",
    "/immigration/hnc": "hnc",
    "/visa/business": "business-visa",
    "/visa/caregiver": "caregiver-visa",
    "/visa/student": "student-visa",
    "/visa/super": "super-visa",
    "/visa/visitor": "visitor-visa",
    "/visa/work": "work-permit"
}

export const socialNetworkingLinks = {
    x: "",
    facebook: "https://www.facebook.com/share/1BXxDVaLKa/?mibextid=wwXIfr",
    instagram: "https://www.instagram.com/bgimmigrationofficial",
    youtube: 'https://youtube.com/@bgimmigrationofficial?si=4xCXgIpRrtaiS5f3'
}